/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onbilgi_S2_Li5Inputs */

const tr_onbilgi_s2_li5 = /** @type {(inputs: Onbilgi_S2_Li5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Finansal raporlama`)
};

const en_onbilgi_s2_li5 = /** @type {(inputs: Onbilgi_S2_Li5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Financial reporting`)
};

const de_onbilgi_s2_li5 = /** @type {(inputs: Onbilgi_S2_Li5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Finanzberichte`)
};

const ru_onbilgi_s2_li5 = /** @type {(inputs: Onbilgi_S2_Li5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Финансовая отчётность`)
};

/**
* | output |
* | --- |
* | "Financial reporting" |
*
* @param {Onbilgi_S2_Li5Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const onbilgi_s2_li5 = /** @type {((inputs?: Onbilgi_S2_Li5Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onbilgi_S2_Li5Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onbilgi_s2_li5(inputs)
	if (locale === "de") return de_onbilgi_s2_li5(inputs)
	if (locale === "ru") return ru_onbilgi_s2_li5(inputs)
	return tr_onbilgi_s2_li5(inputs)
});